import { render, staticRenderFns } from "./footerBtns.vue?vue&type=template&id=11b1d6f6"
import script from "./footerBtns.vue?vue&type=script&lang=js"
export * from "./footerBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports